import { create } from 'zustand';

interface UIStore {
  // Citations Manager Panel
  citationsManagerOpen: boolean;
  citationsManagerProjectId: string | null;
  editingCitationId: string | null;
  
  openCitationsManager: (projectId: string) => void;
  closeCitationsManager: () => void;
  toggleCitationsManager: (projectId?: string) => void;
  setEditingCitation: (citationId: string | null) => void;
}

export const useUIStore = create<UIStore>((set, get) => ({
  citationsManagerOpen: false,
  citationsManagerProjectId: null,
  editingCitationId: null,
  
  openCitationsManager: (projectId: string) => set({ 
    citationsManagerOpen: true, 
    citationsManagerProjectId: projectId 
  }),
  
  closeCitationsManager: () => set({ 
    citationsManagerOpen: false,
    editingCitationId: null,
  }),
  
  toggleCitationsManager: (projectId?: string) => {
    const { citationsManagerOpen, citationsManagerProjectId } = get();
    if (citationsManagerOpen) {
      set({ citationsManagerOpen: false, editingCitationId: null });
    } else if (projectId || citationsManagerProjectId) {
      set({ 
        citationsManagerOpen: true, 
        citationsManagerProjectId: projectId || citationsManagerProjectId 
      });
    }
  },
  
  setEditingCitation: (citationId: string | null) => set({ editingCitationId: citationId }),
}));
